import { useState } from "react";

import invariant from "tiny-invariant";

import { useInstantWithdrawMutation } from "shared/api/use-instant-withdraw-mutation";
import { useWithdrawAssetMutation } from "shared/api/use-withdraw-asset-mutation";
import BentoLogo from "shared/assets/bento-logo.svg?react";
import BlueCube from "shared/assets/blue-cube.svg?react";
import GreenCube from "shared/assets/green-cube.svg?react";
import WasabiLogo from "shared/assets/wasabi-logo.svg?react";
import { Button } from "shared/ui/button";
import { catchError, notifySuccess } from "shared/ui/toast";
import { TradeDialog, WithdrawFormType } from "widgets/trade";

import { Section } from "../section";
import { BentoContent } from "./bento-content";
import { Card } from "./card";
import { WasabiContent } from "./wasabi-content";

type Props = {
  className?: string;
};

export const DepositSection = (props: Props) => {
  const { className } = props;
  const [isWasabiTradeOpen, setIsWasabiTradeOpen] = useState(false);
  const [isBentoTradeOpen, setIsBentoTradeOpen] = useState(false);

  const withdrawAssetMutation = useWithdrawAssetMutation();
  const instantWithdrawMutation = useInstantWithdrawMutation();

  const handleWasabiWithdraw = async (
    data: WithdrawFormType,
    slippage: string
  ) => {
    try {
      if (data.type === "delay") {
        invariant(data.toCurrency);
        await withdrawAssetMutation.mutateAsync({
          currency: data.toCurrency,
          currencyAmount: data.toValue,
          slippage,
          shareAmount: data.fromValue,
          shareCurrency: data.fromCurrency,
        });

        notifySuccess("Success");
      }
      if (data.type === "basket") {
        await instantWithdrawMutation.mutateAsync({
          amount: data.fromValue,
          currency: data.fromCurrency,
        });
      }
    } catch (error) {
      catchError(error);
    }
  };
  const handleBentoTradeWithdraw = async (
    data: WithdrawFormType,
    slippage: string
  ) => {
    console.log(data, slippage);
  };

  return (
    <>
      <Section className={className}>
        <GreenCube className="animate-float pointer-events-none absolute top-40 -left-40 z-10 hidden size-56 lg:flex" />
        <BlueCube className="animate-float pointer-events-none absolute -right-40 bottom-40 z-10 hidden h-56 w-60 lg:flex" />
        <Card
          className="text-spearmint w-full"
          label="Boosted Points"
          tvl="$40,152,767.30(HARDCODE)"
          title="WASABI Points Farm"
          img={<WasabiLogo className="size-full text-black" />}
          description={`Deposit your favourite stablecoins\nin Wasabi Points Farm`}
          button={
            <Button
              className="w-full"
              variant="spearmint"
              size="56"
              onClick={() => {
                setIsWasabiTradeOpen(true);
              }}
            >
              Deposit
            </Button>
          }
        >
          <WasabiContent />
        </Card>
        <Card
          className="text-ultramarine-blue w-full"
          label="Boosted Points"
          tvl="$40,152,767.30(HARDCODE)"
          title="Bento Yield Farm"
          img={<BentoLogo className="size-full text-black" />}
          description={`Deposit your favorite stablecoins\ninto the Bento Yield Farm to earn boosted yield`}
          button={
            <Button
              onClick={() => setIsBentoTradeOpen(true)}
              className="w-full"
              variant="ultramarineBlue"
              size="56"
            >
              Deposit
            </Button>
          }
        >
          <BentoContent />
        </Card>
      </Section>
      <TradeDialog
        className="text-spearmint"
        theme="spearmint"
        open={isWasabiTradeOpen}
        onOpenChange={setIsWasabiTradeOpen}
        onWithdrawSubmit={handleWasabiWithdraw}
      />
      <TradeDialog
        theme="ultramarineBlue"
        className="text-ultramarine-blue"
        open={isBentoTradeOpen}
        onOpenChange={setIsBentoTradeOpen}
        onWithdrawSubmit={handleBentoTradeWithdraw}
      />
    </>
  );
};
